module.exports = __webpack_public_path__ + "img/second_icon_zhaopian@2x.c2c43667.png";